const translations = {
    title: 'Kontakt',
    description: '',
    canonical: 'string',
    image: '',
    robots: '',
};

export default translations;